import api from '@/services/api'

export default {
  loginUser(user) {
    return api.post(`login/`, user)
              .then(response => response.data)
  },
  registerUser(user) {
    return api.post(`register/`, user)
              .then(response => response.data)
  },
  fetchUsers() {
    return api.get(`users/`)
              .then(response => response.data)
  },
  fetchUserDetail(username) {
    return api.get(`users/${username}/`)
              .then(response => response.data)
  },
  getSettings() {
    return api.get('settings/')
              .then(response => response.data)
  },
  changeSettings(data) {
    return api.post(`settings/`, data)
              .then(response => response.data)
  },
  changePassword(data) {
    return api.post(`change-password/`, data)
              .then(response => response.data)
  },
  confirmResetPassword(data) {
    return api.post(`password-reset/confirm/`, data)
              .then(response => response.data)
  },
  resetPassword(email) {
    return api.post(`password-reset/`, {'email': email})
              .then(response => response.data)
  }
}